import React from "react";

export default function FAQSection({ t }) {
  return (
    <div>
      <h3 style={{
        fontSize: "11px",
        fontWeight: "900",
        letterSpacing: "0.25em",
        textTransform: "uppercase",
        color: "#D4AF37",
        margin: "0 0 16px"
      }}>
        {t.faq_title}
      </h3>
      <div style={{ display: "grid", gap: "12px" }}>
        {t.faqs.map((item) => (
          <details key={item.id} style={{
            background: "rgba(255,255,255,0.03)",
            border: "1px solid rgba(255,255,255,0.08)",
            borderRadius: "12px",
            padding: "14px"
          }}>
            <summary style={{ cursor: "pointer", color: "#fff", fontWeight: 800, fontSize: "12px" }}>
              {item.q}
            </summary>
            <p style={{ color: "#888", fontSize: "13px", lineHeight: 1.55, margin: "10px 0 0" }}>
              {item.a}
            </p>
          </details>
        ))}
      </div>
    </div>
  );
}
